<div class="col-xxl-6 ml-2">
    <p>{{ label }}</p>
    <h6>{{ value }}</h6>
  </div>
  